
import { Component, Vue } from 'vue-property-decorator'
import HeaderSearch from '@/components/componentWap/HeaderSearch.vue'
@Component({
    name: 'VideoList',
    components: {
        HeaderSearch
    }
})
export default class extends Vue {
    created() {
        if(this.$isWap) {
            const token = this.$route.query.token as string
            if (!token) return
            localStorage.setItem('token', token)
            this.$jump('/index')
        } else {
            location.href = '/'
        }
    }
}
